/**
 * BE rules: `initial` → show now; `two_weeks` / `thirty_days` → show when now >= next_prompt_at.
 */
export function shouldShowNasaTlxFromPreference(
  p: INasaTlxPreferenceResponse,
  now = new Date()
): boolean {
  if (p.prompt_status === "initial") {
    return true;
  }
  if (!p.next_prompt_at) {
    return false;
  }
  return now.getTime() >= new Date(p.next_prompt_at).getTime();
}
